var m = require('mithril');
var layout = require('../layout/layout');
var alarm = require('./alarms');
var snapshot = require('./snapshot');
var alarmProfileEditor = require('./alarmProfileEditor');
var alarmProfiles = require('./alarmProfiles');

module.exports = {

  '/alarms': {
    view: function() {
      return m(layout, m(alarm));
    },
  },
  '/snapshot/:incidentId': {
    view: function() {
      return m(layout, m(snapshot));
    },
  },
  '/alarmprofile/:id': {
    view: function() {
      return m(layout, m(alarmProfileEditor));
    },
  },
  '/alarmprofile': {
    view: function() {
      return m(layout, m(alarmProfiles));
    },
  }
};
